exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-scrollbar .el-scrollbar__wrap {\n  overflow-x: hidden;\n}\n#uploadToTree #pleaseSelect .el-loading-spinner .circular {\n  height: 25px !important;\n  width: 25px !important;\n}", "", {"version":3,"sources":["D:/WorkProjects-git/MultCloud/Project/mcFrontend/src/components/popup/remote_task_popups/upload_to_tree_popup.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;CACpB;AAED;EACE,wBAAwB;EACxB,uBAAuB;CACxB","file":"upload_to_tree_popup.vue","sourcesContent":[".el-scrollbar .el-scrollbar__wrap {\n  overflow-x: hidden;\n}\n\n#uploadToTree #pleaseSelect .el-loading-spinner .circular {\n  height: 25px !important;\n  width: 25px !important;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18d18375","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/remote_task_popups/upload_to_tree_popup.vue
// module id = /IO5
// module chunks = 2